import {createContext, useContext} from "react";

export const PreachingContext = createContext(null);
export const usePreachingContext = () => useContext(PreachingContext)